// User message bubble: right-aligned, accent-coloured pill. The controller
// never produces user-side tool-calls or attachments, so plain text only.

import React from "react";
import { MessagePrimitive } from "@assistant-ui/react";

export function UserMessage() {
  return (
    <MessagePrimitive.Root className="tw-flex tw-w-full tw-justify-end tw-py-1">
      <div className="tw-max-w-[85%] tw-rounded-2xl tw-rounded-br-md tw-bg-copilot-primary tw-px-3.5 tw-py-2 tw-text-sm tw-text-copilot-primary-foreground tw-shadow-sm">
        <MessagePrimitive.Content
          components={{
            Text: ({ text }) => (
              <span className="tw-whitespace-pre-wrap tw-break-words">{text}</span>
            ),
          }}
        />
      </div>
    </MessagePrimitive.Root>
  );
}
